import { RiAddLine, RiSubtractLine } from '@remixicon/react'
import { Button, Group, Input, NumberField } from 'react-aria-components'

import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface NumberInputProps {
  defaultValue?: number
  minValue?: number
  maxValue?: number
  step?: number
  className?: string
  disabled?: boolean
  value: number
  onChange: (value: number) => void
}

export const NumberInput = ({
  step = 1,
  defaultValue = 0,
  minValue = Number.MIN_SAFE_INTEGER,
  maxValue = Number.MAX_SAFE_INTEGER,
  disabled,
  value,
  className,
  onChange
}: NumberInputProps) => {
  return (
    <NumberField
      value={value}
      onChange={onChange}
      isWheelDisabled
      formatOptions={{
        useGrouping: false
      }}
      defaultValue={defaultValue}
      minValue={minValue}
      maxValue={maxValue}
      isDisabled={disabled}
      step={step}
    >
      <Group
        className={cn(
          'border-grey-300 data-focus-within:border-ring data-focus-within:ring-ring relative inline-flex h-9 w-full min-w-30 items-center overflow-hidden rounded-md border text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none data-disabled:opacity-50 data-focus-within:ring-[3px] data-focus-within:has-aria-invalid:border-red-300 data-focus-within:has-aria-invalid:ring-red-300/20 dark:data-focus-within:has-aria-invalid:ring-red-300/40',
          className
        )}
      >
        <Button
          slot='decrement'
          className={cn(
            'bg-white-200 [&_svg]:!text-black-200 hover:!bg-white-200 disabled:!bg-white-200 -ms-px aspect-square h-[inherit] rounded-s-md',
            buttonVariants({ size: 'icon', variant: 'ghost' })
          )}
        >
          <RiSubtractLine aria-hidden='true' />
        </Button>
        <Input className='bg-white-200 text-grey-500 w-full grow p-2.5 text-center tabular-nums outline-none' />
        <Button
          slot='increment'
          className={cn(
            'bg-white-200 [&_svg]:!text-black-200 hover:!bg-white-200 disabled:!bg-white-200 -me-px aspect-square h-[inherit] rounded-e-md',
            buttonVariants({ size: 'icon', variant: 'ghost' })
          )}
        >
          <RiAddLine aria-hidden='true' />
        </Button>
      </Group>
    </NumberField>
  )
}
